/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabeledValueDto
 */
export interface LabeledValueDto {
    /**
     * The value, for example a connection URL or an image version.
     * @type {string}
     * @memberof LabeledValueDto
     */
    value: string;
    /**
     * Whether this value is publicly visible to the customer.
     * @type {boolean}
     * @memberof LabeledValueDto
     */
    isPublic: boolean;
    /**
     * Human-readable label for the value.
     * @type {string}
     * @memberof LabeledValueDto
     */
    label: string;
}

/**
 * Check if a given object implements the LabeledValueDto interface.
 */
export function instanceOfLabeledValueDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "isPublic" in value;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function LabeledValueDtoFromJSON(json: any): LabeledValueDto {
    return LabeledValueDtoFromJSONTyped(json, false);
}

export function LabeledValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabeledValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'isPublic': json['isPublic'],
        'label': json['label'],
    };
}

export function LabeledValueDtoToJSON(value?: LabeledValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'isPublic': value.isPublic,
        'label': value.label,
    };
}

